<template>
    <!-- 商户进件 -->
    <div class="merchantList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
               
              <el-form-item>
				  <el-input
					  size
					  clearable
					  v-model="searchForm.tel"
					  placeholder="请输入商户手机号"
				  ></el-input>
              </el-form-item>
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="searchForm.merchant_number"
                        placeholder="请输入商户编号"
                    ></el-input>
                </el-form-item>
               <el-form-item>
                   <el-input
                       size
                       clearable
                       v-model="searchForm.agent_tel"
                       placeholder="请输入代理商手机号"
                   ></el-input>
               </el-form-item>
			   <el-form-item>
			       <el-input
			           size
			           clearable
			           v-model="searchForm.agent_no"
			           placeholder="请输入代理商编号"
			       ></el-input>
			   </el-form-item>
			   <el-form-item>
			       <el-input
			           size
			           clearable
			           v-model="searchForm.sn"
			           placeholder="请输入原始SN"
			       ></el-input>
			   </el-form-item>
			   <el-form-item>
			       <el-input
			           size
			           clearable
			           v-model="searchForm.unbind_sn"
			           placeholder="请输入解绑后SN"
			       ></el-input>
			   </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="解绑开始日期"
                        end-placeholder="解绑结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                :data="marchantList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                
                <!-- 原始SN -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="sn"
                    label="原始SN"
                    min-width="120"
                ></el-table-column>
                <!-- 解绑后SN -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="unbind_sn"
                    label="解绑后SN"
                    min-width="120"
                ></el-table-column>
				<!-- 商户名称 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="merchant_name"
				    label="商户名称"
				    min-width="120"
				></el-table-column>
				<!-- 商户手机号 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="tel"
				    label="商户手机号"
				    min-width="120"
				>
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.tel | desMobile" placement="top">
              <p>{{ scope.row.tel | desMobile }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
				<!-- 商户编号 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="merchant_number"
				    label="商户编号"
				    min-width="120"
				></el-table-column>
        <!-- 代理商名称 -->
        <el-table-column
            header-align="center"
            align="center"
            prop="agent_name"
            label="代理商名称"
            min-width="120"
        ></el-table-column>
        <!-- 代理商手机号 -->
        <el-table-column
            header-align="center"
            align="center"
            prop="agent_tel"
            label="代理商手机号"
            min-width="120"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="scope.row.agent_tel | desMobile" placement="top">
              <p>{{ scope.row.agent_tel | desMobile }}</p>
            </el-tooltip>
          </template>
        </el-table-column>
				<!-- 代理商编号 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="agent_no"
				    label="代理商编号"
				    min-width="120"
				></el-table-column>
              <!-- 绑定时间 -->
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="bind_time"
                  label="绑定时间"
                  min-width="120"
              ></el-table-column>
              <!-- 解绑时间 -->
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="unbind_time"
                  label="解绑时间"
                  min-width="120"
              ></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "merchant-net",
    data() {
        return {
            isAdd: false, //
            toolsIsShow: false, //修改代理商
            searchForm: {
                tel: '',
                merchant_number:'',
				agent_tel:'',
				agent_no:'',
				sn:'',
				unbind_sn:'',
                start_unbind_time: '',
                end_unbind_time: '',
            },
            rangeDate: '',
            id:'',
            marchantList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            level: sessionStorage.getItem('level'),
            dialogData: {
                data: {} //当前行的数据
            },
        }
    },
    created() {

    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    methods: {
        onSearch(searchFrom) {
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("terminal/terminalUnbindList", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.marchantList = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_unbind_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_unbind_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
    }
}
</script>

<style scoped lang="scss">
.merchantList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>